export function fontColorToLinearGradient(color) {
  switch (color) {
    case "#333333":
      // return { background: "linear-gradient(180deg, #202020 0%, #A8A8A8 100%)" };
      return { backgroundImage: "url(" + require("@/assets/img/level2/0.png") + ")" };
    case "#3ED998":
      // return { background: "linear-gradient(180deg, #18A2FF 0%, #AADCFF 100%)" };
      return { backgroundImage: "url(" + require("@/assets/img/level2/2.png") + ")" };
    case "#5599F2":
      // return { background: "linear-gradient(180deg, #CAE6FF 0%, #6171FF 100%)" };
      return { backgroundImage: "url(" + require("@/assets/img/level2/8.png") + ")" };
    case "#C154F3":
      // return { background: "linear-gradient(180deg, #FF6C8A 0%, #FFB5C4 100%)" };
      return { backgroundImage: "url(" + require("@/assets/img/level2/16.png") + ")" };
    case "#FF6B00":
      // return { background: "linear-gradient(180deg, #FFA000 0%, #FFE600 100%)" };
      return { backgroundImage: "url(" + require("@/assets/img/level2/21.png") + ")" };
    case "#E41EB1":
      // return { background: "linear-gradient(180deg, #E41EB1 0%, #FF99E5 100%)" };
      return { backgroundImage: "url(" + require("@/assets/img/level2/s1.png") + ")" };
    case "#113BD0":
      // return { background: "linear-gradient(180deg, #2952E2 0%, #66C7FD 100%)" };
      return { backgroundImage: "url(" + require("@/assets/img/level2/8.png") + ")" };
    default:
      // return { background: "linear-gradient(180deg, #202020 0%, #A8A8A8 100%)" };
      return { backgroundImage: "url(" + require("@/assets/img/level2/0.png") + ")" };
  }
}

export function fontColorToBackgroundColor(color) {
  switch (color) {
    case "#333333":
      // return { background: " linear-gradient(0deg, rgba(174, 174, 174, 0.05), rgba(174, 174, 174, 0.05))" };
      return { background: "rgba(102, 102, 102, 0.05)" };
    case "#3ED998":
      // return { background: " linear-gradient(0deg, rgba(24, 162, 255, 0.05), rgba(24, 162, 255, 0.05))" };
      return { background: "rgba(13, 164, 100, 0.05)" };
    case "#5599F2":
      // return { background: " linear-gradient(0deg, rgba(97, 113, 255, 0.05), rgba(97, 113, 255, 0.05))" };
      return { background: "rgba(38, 116, 215, 0.05)" };
    case "#C154F3":
      // return { background: " linear-gradient(0deg, rgba(255, 108, 138, 0.05), rgba(255, 108, 138, 0.05))" };
      return { background: "rgba(156, 23, 219, 0.05)" };
    case "#FF6B00":
      return { background: " linear-gradient(0deg, rgba(255, 160, 0, 0.05), rgba(255, 160, 0, 0.05))" };
    case "#E41EB1":
      return { background: " linear-gradient(0deg, rgba(228, 30, 177, 0.08), rgba(228, 30, 177, 0.08))" };
    case "#113BD0":
      return { background: "linear-gradient(0deg, rgba(17, 59, 208, 0.08), rgba(17, 59, 208, 0.08))" };
    default:
      return { background: "rgba(102, 102, 102, 0.05)" };
  }
}

export function levelToLinearGradient(level) {
  if (level >= 0 && level < 2) {
    // return { background: "linear-gradient(180deg, #202020 0%, #A8A8A8 100%)" };
    return { backgroundImage: "url(" + require("@/assets/img/level2/0.png") + ")" };
  }
  if (level >= 2 && level < 8) {
    // return { background: "linear-gradient(180deg, #18A2FF 0%, #AADCFF 100%)" };
    return { backgroundImage: "url(" + require("@/assets/img/level2/2.png") + ")" };
  }
  if (level >= 8 && level < 16) {
    // return { background: "linear-gradient(180deg, #CAE6FF 0%, #6171FF 100%)" };
    return { backgroundImage: "url(" + require("@/assets/img/level2/8.png") + ")" };
  }
  if (level >= 16 && level < 21) {
    // return { background: "linear-gradient(180deg, #FF6C8A 0%, #FFB5C4 100%)" };
    return { backgroundImage: "url(" + require("@/assets/img/level2/16.png") + ")" };
  }
  if (level >= 21) {
    // return { background: "linear-gradient(180deg, #FFA000 0%, #FFE600 100%)" };
    return { backgroundImage: "url(" + require("@/assets/img/level2/21.png") + ")" };
  }
}

export function propsToBg(props_id) {
  if (props_id === 2) {
    return { background: "rgba(17, 59, 208, 0.08)" };
  } else if (props_id === 3) {
    return { background: "rgba(228, 30, 177, 0.08)" };
  } else if (props_id === 4) {
    return { background: "rgba(255, 122, 0, 0.08)" };
  } else {
    return { background: "" };
  }
}

export function levelToFontColor(level) {
  if (level >= 0 && level < 2) {
    return { color: "#333333" };
  }
  if (level >= 2 && level < 8) {
    return { color: "#0098FF" };
  }
  if (level >= 8 && level < 16) {
    return { color: "#5669FF" };
  }
  if (level >= 16 && level < 21) {
    return { color: "#F34F4F" };
  }
  if (level >= 21) {
    return { color: "#FFA400" };
  }
}

export function levelToBg(level) {
  if (level >= 0 && level < 1) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V0.png") + ")" };
  } else if (level == 1 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V1.png") + ")" };
  } else if (level == 2 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V2.png") + ")" };
  }else if (level == 3 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V3.png") + ")" };
  }else if (level == 4 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V4.png") + ")"};
  }else if (level == 5 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V5.png") + ")"};
  }else if (level == 6 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V6.png") + ")"};
  } else if (level == 7 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V7.png") + ")" };
  }else if (level == 8 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V8.png") + ")" };
  }else if (level == 9 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V9.png") + ")" };
  } else if (level == 10 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V10.png") + ")" };
  } else if (level == 11 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V11.png") + ")" };
  }else if (level == 12 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V12.png") + ")" };
  }else if (level == 13 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V13.png") + ")" };
  }else if (level == 14 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V14.png") + ")" };
  }else if (level == 15 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V15.png") + ")" };
  } else if (level == 16 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V16.png") + ")"};
  } else if (level == 17 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V17.png") + ")"};
  }else if (level == 18 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V18.png") + ")"};
  }else if (level == 19 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V19.png") + ")" };
  }else if (level == 20 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V20.png") + ")" };
  }else if (level == 21 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V21.png") + ")" };
  } else if (level == 22 ) {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V22.png") + ")" };
  } else {
    return { backgroundImage: "url(" + require("@/assets/img/level3/V23.png") + ")" };
  }
}
